import { Link } from "react-router-dom";
import MangaNavbar from "@/components/feature/MangaNavbar";
import MangaFooter from "@/components/feature/MangaFooter";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumb from "@/components/feature/MangaBreadcrumb";
import JsonLd from "@/components/feature/JsonLd";
import { useSeo } from "@/hooks/useSeo";
import { faqItems } from "@/mocks/comics";

const breadcrumbItems = [{ label: "首页", to: "/" }, { label: "常见问题" }];

export default function Faq() {
  useSeo({
    title: "常见问题 - 天天漫画网追更指南与帮助",
    description:
      "天天漫画网常见问题：每天几点更新最新话？追更需要注册吗？如何开启追更提醒？日漫与国漫更新频率一样吗？一站式解答你的追更疑问。",
    keywords: "天天漫画网常见问题,追更指南,漫画更新时间,漫画追更帮助,追更提醒",
    canonicalPath: "/faq",
  });

  const faqData = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqItems.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <>
      <JsonLd id="faq-jsonld" data={faqData} />
      <MangaNavbar />
      <Breadcrumb items={breadcrumbItems} />
      <main className="max-w-3xl mx-auto px-4 md:px-6 py-8 md:py-12">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium text-primary-600 bg-primary-100 px-3 py-1 rounded-full">
            <i className="ri-question-answer-fill"></i>帮助中心
          </span>
          <h1 className="mt-3 font-heading text-3xl md:text-5xl text-foreground-950">常见问题</h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500">
            关于追更、收藏与更新提醒的疑问，这里一次性说清。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqItems.map((item, idx) => (
            <details key={idx} className="group rounded-2xl bg-background-50 border border-background-200 p-5 open:border-primary-200 open:bg-background-100/60">
              <summary className="flex items-center justify-between gap-3 cursor-pointer list-none text-base font-medium text-foreground-900">
                <span className="flex items-start gap-3">
                  <span className="mt-0.5 w-6 h-6 shrink-0 rounded-lg bg-primary-100 text-primary-600 flex items-center justify-center text-xs font-bold">
                    {idx + 1}
                  </span>
                  {item.q}
                </span>
                <span className="shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-600 flex items-center justify-center group-open:bg-primary-500 group-open:text-background-50 transition-colors">
                  <i className="ri-add-line"></i>
                </span>
              </summary>
              <p className="mt-4 pl-9 text-sm md:text-base text-foreground-600 leading-7">{item.a}</p>
            </details>
          ))}
        </div>

        <div className="mt-10 rounded-2xl bg-secondary-50 border border-secondary-200 p-6 md:p-8 text-center">
          <h2 className="font-heading text-xl text-foreground-950">还有疑问？</h2>
          <p className="mt-2 text-sm text-foreground-600">如果没有找到你想要的答案，欢迎随时联系我们，我们会尽快为你解答。</p>
          <Link
            to="/about"
            className="inline-flex items-center gap-1.5 mt-5 h-11 px-7 rounded-full bg-secondary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-secondary-600 transition-colors"
          >
            联系我们 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </main>
      <MangaFooter />
      <BackToTop />
    </>
  );
}